export default __webpack_public_path__ + "static/media/profile.c3a0cf7d.jpg";